import axios from 'axios';

const api = axios.create({ withCredentials: true });

api.interceptors.response.use();

export const fetcher = { api };
